import { useSelector } from 'react-redux'

export default function () {
  return useSelector((state) =>
    state.auth.userData.attributes
      ? state.auth.userData.attributes.email_verified
      : false,
  )
}
